module.exports = __webpack_public_path__ + "static/scale-model-of-minneapolis-sign-in-minneapolis-minnesota-c49a31e46d0990ff8267bce5d20f6cd1.png";